import {
  IconBed,
  IconUsers,
  IconLuggage,
  IconCalendarCheck,
  IconCalendarX,
  IconCurrencyEuro
} from '@tabler/icons-react'
import KPICard from '@/components/dashboard/KPICard'
import QuickActions from '@/components/dashboard/QuickActions'
import UpcomingReserves from '@/components/dashboard/UpcomingReserves'
import { useDashboardStats } from '@/hooks/useDashboardStats'

export default function DashboardPage() {
  const { data: stats, isLoading: loading } = useDashboardStats()

  const defaultStats = {
    totalReserves: 0,
    checkinsToday: 0,
    checkoutsToday: 0,
    totalClients: 0,
    totalViatgers: 0,
    monthlyRevenue: 0,
    occupancyRate: 0
  }

  const currentStats = stats || defaultStats

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
          <p className="text-gray-600 mt-1">Visió general del sistema</p>
        </div>
      </div>

      {/* KPI Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
        <KPICard
          title="Total Reserves"
          value={currentStats.totalReserves}
          icon={<IconBed className="w-6 h-6 text-blue-600" />}
          colorClass="text-blue-600"
          loading={loading}
        />

        <KPICard
          title="Check-ins Avui"
          value={currentStats.checkinsToday}
          icon={<IconCalendarCheck className="w-6 h-6 text-green-600" />}
          colorClass="text-green-600"
          loading={loading}
        />

        <KPICard
          title="Check-outs Avui"
          value={currentStats.checkoutsToday}
          icon={<IconCalendarX className="w-6 h-6 text-orange-600" />}
          colorClass="text-orange-600"
          loading={loading}
        />

        <KPICard
          title="Total Clients"
          value={currentStats.totalClients}
          icon={<IconUsers className="w-6 h-6 text-purple-600" />}
          colorClass="text-purple-600"
          loading={loading}
        />

        <KPICard
          title="Total Viatgers"
          value={currentStats.totalViatgers}
          icon={<IconLuggage className="w-6 h-6 text-indigo-600" />}
          colorClass="text-indigo-600"
          loading={loading}
        />

        <KPICard
          title="Ingressos del Mes"
          value={loading ? '...' : `${currentStats.monthlyRevenue.toFixed(0)}€`}
          icon={<IconCurrencyEuro className="w-6 h-6 text-emerald-600" />}
          colorClass="text-emerald-600"
          loading={loading}
        />
      </div>

      {/* Quick Actions */}
      <QuickActions />

      {/* Upcoming Reserves */}
      <UpcomingReserves />
    </div>
  )
}
